




































































































































import { apiClient } from "@/services/api-client";
import LoadingBlock from "../components/LoadingBlock.vue";
import { mapGetters } from "vuex";
import NoLocationSelected from "../components/NoLocationSelected.vue";
import BaseIconAlert from "../components/Base/BaseIconAlert.vue";
import TheBannerSmall from "@/components/The/TheBannerSmall.vue";
import BaseBreadcrumb from "@/components/Base/BaseBreadcrumb.vue";
import TableDynamic from "@/components/TableDynamic.vue";
import BasePage from "@/components/Base/BasePage.vue";
import { logPageMixin } from "@/mixins/LogPageMixin";
import DocumentsTable from "@/components/DocumentsTable.vue";
import { errorHandlingApiResponse } from "@/mixins/errorHandlingApiResponse";

export default {
  name: "Materieelvoorraad",
  components: {
    BasePage,
    TableDynamic,
    BaseBreadcrumb,
    TheBannerSmall,
    BaseIconAlert,
    NoLocationSelected,
    LoadingBlock,
    DocumentsTable
  },
  mixins: [logPageMixin, errorHandlingApiResponse],
  data() {
    return {
      items: [],
      isLoading: false as boolean,
      searchValue: "",
      breadcrumbs: [
        {
          text: this.$t("Locatie.title"),
          to: { name: "Locatie" }
        },
        {
          text: this.$t("MaterieelKeuringen.title")
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "selectedLocationId",
      "selectedLocationName",
      "getMultiSetting",
      "getColumnSetting"
    ]),
    fields() {
      return [
        {
          key: this.getColumnSetting("Keuringen_MaterieelSoort").isEnabled
            ? "materieelSoort"
            : null,
          label: this.$t("shared.materieelsoort"),
          order: this.getColumnSetting("Keuringen_MaterieelSoort").order,
          sortable: true
        },
        {
          key: this.getColumnSetting("Keuringen_MaterieelNummer").isEnabled
            ? "materieelNummer"
            : null,
          label: this.$t("shared.nummer"),
          order: this.getColumnSetting("Keuringen_MaterieelNummer").order,
          sortable: true
        },
        {
          key: this.getColumnSetting("Keuringen_MaterieelOmschrijving")
            .isEnabled
            ? "materieelOmschrijving"
            : null,
          label: this.$t("shared.omschrijving"),
          order: this.getColumnSetting("Keuringen_MaterieelOmschrijving").order,
          sortable: true
        },
        {
          key: this.getColumnSetting("Keuringen_KeuringsType").isEnabled
            ? "keuringsType"
            : null,
          label: this.$t("MaterieelKeuringen.keuringsType"),
          order: this.getColumnSetting("Keuringen_KeuringsType").order,
          sortable: true
        },
        {
          key: this.getColumnSetting("Keuringen_KeuringOmschrijving").isEnabled
            ? "keuringOmschrijving"
            : null,
          label: this.$t("MaterieelKeuringen.keuringOmschrijving"),
          order: this.getColumnSetting("Keuringen_KeuringOmschrijving").order,
          sortable: true
        },
        {
          key: this.getColumnSetting("Keuringen_KeuringsResultaat").isEnabled
            ? "keuringsResultaat"
            : null,
          label: this.$t("MaterieelKeuringen.keuringsResultaat"),
          order: this.getColumnSetting("Keuringen_KeuringsResultaat").order,
          sortable: true
        },
        {
          key: this.getColumnSetting("Keuringen_KeurenVoorDatum").isEnabled
            ? "keurenVoorDatum"
            : null,
          label: this.$t("MaterieelKeuringen.keurenVoorDatum"),
          order: this.getColumnSetting("Keuringen_KeurenVoorDatum").order,
          sortable: true
        },
        {
          key: this.getColumnSetting("Keuringen_KeuringsDatum").isEnabled
            ? "keuringsDatum"
            : null,
          label: this.$t("MaterieelKeuringen.keuringsDatum"),
          order: this.getColumnSetting("Keuringen_KeuringsDatum").order,
          sortable: true
        }
      ];
    }
  },
  created() {
    if (!this.selectedLocationId) {
      return;
    }

    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      apiClient
        .getKeuringen({
          materieelLocatie: this.selectedLocationId
        })
        .then(response => {
          this.items = response.items;
        })
        .catch(error => {
          errorHandlingApiResponse.methods.getSnackbarText(error.status);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    beforeRouteEnter(to, from, next) {
      next();
    }
  }
};
